// libraries
import { TrialDuration } from "@clockwise/web-commons/src/util/trial-constants";
import pluralize from "pluralize";
import React from "react";
import { useDispatch } from "react-redux";
import { stylingForBanner } from "./trial-banner-side-menu.util";

// util
import { setPricingDialogOpen } from "#webapp/src/state/actions/payments.actions";
import { track, TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";
// material-ui
import { ArrowUpward, Info } from "@clockwise/design-system/icons";
import { openBillingPage } from "@clockwise/web-commons/src/util/upgradeLinks.util";

export type TrialBannerSideMenuProps = {
  daysLeft: number | null;
  showJoinExistingPlan?: boolean;
};

export const TrialBannerSideMenu = ({
  daysLeft,
  showJoinExistingPlan,
}: TrialBannerSideMenuProps) => {
  const dispatch = useDispatch();

  if (!daysLeft || daysLeft <= 0) return null;

  let status: "gray" | "blue" | "red" = "gray";
  if (daysLeft <= TrialDuration.lastChanceNotification) {
    status = "red";
  } else if (daysLeft > TrialDuration.twoWeeksIn) {
    status = "gray";
  } else {
    status = "blue";
  }

  const onSelectCTA = () => {
    if (showJoinExistingPlan) {
      track(TrackingEvents.PAYWALLS.SIDEMENU_TRIAL_BANNER_JOIN_PLAN_CLICKED, {
        daysLeft: daysLeft,
      });
      openBillingPage();
    } else {
      track(TrackingEvents.PAYWALLS.SIDEMENU_TRIAL_BANNER_UPGRADE_CLICKED, { daysLeft: daysLeft });
      if (daysLeft > TrialDuration.twoWeeksIn) {
        dispatch(setPricingDialogOpen(true));
      } else {
        dispatch(setPricingDialogOpen(true, undefined, "Checkout"));
      }
    }
  };

  return (
    <div
      className={`${stylingForBanner[status].backgroundColor} ${stylingForBanner[status].textColor} cw-w-full cw-font-body cw-py-2 cw-px-1 cw-font-bold cw-text-[11px] cw-flex cw-items-center cw-justify-between`}
    >
      <div className="cw-flex cw-items-center cw-gap-1">
        <Info className={`${stylingForBanner[status].iconColor} cw-w-4 cw-h-4 cw-ml-2`} />
        <span>{`${daysLeft} ${pluralize("day", daysLeft)} left on your Teams trial`}</span>
      </div>
      <span
        onClick={onSelectCTA}
        className={`cw-flex cw-no-underline cw-items-center cw-gap-1 cw-cursor-pointer hover:cw-underline`}
      >
        {showJoinExistingPlan ? "JOIN A PLAN" : "UPGRADE"}
        <ArrowUpward
          className={`${stylingForBanner[status].iconColor} cw-w-4 cw-h-4 cw-rotate-45`}
        />
      </span>
    </div>
  );
};
